import { CheckCircle2, XCircle, AlertTriangle } from "lucide-react";

export const BYTES_PER_KB = 1024;

export const STATUS_ICON = {
  FOUND: CheckCircle2,
  NOT_FOUND: XCircle,
  INVALID: AlertTriangle,
  NO_RANGE: AlertTriangle,
  ERROR: AlertTriangle,
};

export const STATUS_COLOR = {
  FOUND: "text-[#22C55E]",
  NOT_FOUND: "text-[#EF4444]",
  INVALID: "text-[#F59E0B]",
  NO_RANGE: "text-[#F59E0B]",
  ERROR: "text-[#EF4444]",
};

export function statusTextColor(status) {
  if (status === "FOUND") return "text-[#22C55E]";
  if (status === "NOT_FOUND") return "text-[#EF4444]";
  return "text-[#F59E0B]";
}
